/* eslint-disable react/prop-types */
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { check_flavours } from '../../constant/check_flavours';
import { TYPE_CONSTANT } from '../../constant/Web_constant';
import { refreshPage } from '../../store/feature/authSlice';

import { setGeneralConfig } from '../../store/feature/configsSlice';
import { all_accounts_page } from '../../tradly.config';
import Error from 'next/error';
import tradly from 'tradly';
import {
  set_domain_name,
  encryptDataWithAES,
  decryptDataWithAES,
  set_host_name,
} from '../../constant/sdk_set';
import {
  all_integrations_data,
  metadata,
  structuredData,
} from '../../constant/Metadata';
import { seo_text } from '../../constant/static_text';
import SEO_Head from '../../constant/SEO_Head';
import { Common_ssr_functions } from '../../constant/SSR_functions';
import {
  set_root_configs,
  ssr_configs_set,
} from '../../constant/Root_configs_set';
import { useRouter } from 'next/router';
import { ssr_translation_functions } from '../../constant/Translation/SSR_translation';
import { Menubar_text } from '../../constant/Translation/Heading';
import { General_text } from '../../constant/Translation/General';
import { Account_text } from '../../constant/Translation/Account';
import { Notification_text } from '../../constant/Translation/Notification';
import { Listing_text } from '../../constant/Translation/Listing';
import { Following_text } from '../../constant/Translation/Following';
import { set_root_translation } from '../../constant/Translation/translation_set';
import { getReplacePageKey } from '../../utils/getReplacePageKey';
import { PAGE_KEY } from '../../constant/PageKeys';
import DynamicPagesLayout from '../../themes/blank/DynamicPagesLayout';

const Stores = ({ configs_list_data, client_translations }) => {
  const [MARKETPLACE_FLAVOURS, setMARKETPLACE_FLAVOURS] = useState(null);

  const dispatch = useDispatch();
  const router = useRouter();

  // Configs decryption
  const [configs_list, setConfigsList] = useState(
    JSON.parse(decryptDataWithAES(configs_list_data))
  );

  useEffect(() => {
    // Decrypt the data when the prop value changes
    const decryptedValue = JSON.parse(decryptDataWithAES(configs_list_data));
    setConfigsList(decryptedValue);
  }, [configs_list_data]);

  // refresh action call
  useEffect(() => {
    window.addEventListener('focus', () => {
      dispatch(refreshPage({}));
    });
    dispatch(refreshPage({}));
  }, []);

  //
  useEffect(() => {
    const general_configs = TYPE_CONSTANT.GENERAL_CONFIGS;

    dispatch(setGeneralConfig({ general_configs: general_configs }));
    setMARKETPLACE_FLAVOURS(
      Number(localStorage.getItem('MARKETPLACE_FLAVOURS'))
    );
  }, []);

  // SEO meat data
  metadata.title = seo_text.all_accounts_page_title;
  metadata.meta_description = seo_text.all_accounts_page_description;
  metadata.image = configs_list?.seo?.meta_image
    ? configs_list?.seo?.meta_image
    : configs_list?.general?.web_logo;
  all_integrations_data.google_tag_manager =
    configs_list?.integrations?.google_tag_manager;

  all_integrations_data.facebook_pixel =
    configs_list?.integrations?.facebook_pixel;
  structuredData.json_data = {};
  metadata.url = typeof window !== 'undefined' && window.location.href;
  //
  if (typeof window !== 'undefined') {
    set_root_configs({
      is_draft: router?.query?.draft,
      all_configs: configs_list,
    });

    // translation set
    set_root_translation({
      translation_values: client_translations,
      group_names: [
        'more',
        'general',
        'storelist',
        'storedetail',
        'notification',
        'product',
        'productlist',
        'productschedule',
        'producttime',
        'following',
      ],
      translation_file: [
        Menubar_text,
        General_text,
        Account_text,
        Notification_text,
        Listing_text,
        Following_text,
      ],
    });
  }

  const isReplacePageAvailable = getReplacePageKey(
    configs_list?.pages?.replaced_dynamic_pages,
    PAGE_KEY.account
  );

  return check_flavours(2) ? (
    <Error statusCode={404} />
  ) : (
    <>
      <SEO_Head />
      {isReplacePageAvailable && (
        <DynamicPagesLayout
          dynamic_page_details={{ slug: isReplacePageAvailable }}
        />
      )}
      {!isReplacePageAvailable && all_accounts_page()}
    </>
  );
};

export default Stores;

// Server Side Function
export async function getServerSideProps({ params, req, res, query }) {
  var host = set_domain_name(req);

  const auth_key = req.cookies[`${set_host_name(req)}_auth_key`];
  let default_language =
    req.cookies[`${set_host_name(req)}_default_language`] ?? undefined;
  const currency = req.cookies[`${set_host_name(req)}_default_currency`];

  // SSR FUnctions
  const { configs_list } = await Common_ssr_functions({
    host,
    auth_key,
    currency,
    req,
    res,
    query,
  }).then(async (res) => {
    return res;
  });

  // console.log('>>>>>>>>>>>>>>>>>>>',   configs_list);

  // configs set
  ssr_configs_set({ is_draft: query.draft, all_configs: configs_list });

  //client_translations
  const { client_translations } = await ssr_translation_functions({
    host,
    auth_key,
    currency,
    req,
    res,
    query,
    translation_group: [
      'more',
      'general',
      'storelist',
      'storedetail',
      'notification',
      'product',
      'productlist',
      'productschedule',
      'producttime',
      'following',
    ],
    translation_file: [
      Menubar_text,
      General_text,
      Account_text,
      Notification_text,
      Listing_text,
      Following_text,
    ],
  }).then(async (res) => {
    return res;
  });

  // SEO meat data
  metadata.title = seo_text.all_accounts_page_title;
  metadata.meta_description = seo_text.all_accounts_page_description;
  metadata.url = req?.headers?.host + req?.url;
  metadata.image = configs_list?.seo?.meta_image
    ? configs_list?.seo?.meta_image
    : configs_list?.general?.web_logo;
  all_integrations_data.google_tag_manager =
    configs_list?.integrations?.google_tag_manager;

  all_integrations_data.facebook_pixel =
    configs_list?.integrations?.facebook_pixel;
  structuredData.json_data = {};

  return {
    props: {
      configs_list_data: encryptDataWithAES(JSON.stringify(configs_list)),
      client_translations,
    },
  };
}
